import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { ADTSpecificationFormValues } from '../../../models/adt-specification-form-values';
import { ADT_SPECIFICATION_ACTION_TYPES, AdtSpecificationActions } from '../../actions/adt-specifications.actions';
import { SpecificationFormEnum } from '../../../../specification/models/specification-form.enum';

/**
 * Interface state of Admixture specification form store
 */
export interface AdtSpecificationFormState {
  config: FieldConfig[];
  forms: ADTSpecificationFormValues[];
  canAddMultipleProducts: boolean;
  formsCounter: number;
  dateSelection: string;
  mainFormId?: number;
}

/**
 * initial state of Admixture specification form store
 */
export const initialState: AdtSpecificationFormState = {
  config: undefined,
  forms: [{ id: 0, values: {}, type: SpecificationFormEnum.PRODUCT_FORM }],
  canAddMultipleProducts: false,
  formsCounter: 0,
  dateSelection: undefined,
  mainFormId: undefined,
};

/**
 * Admixture specification form reducer
 * @param {AdtSpecificationFormState} state
 * @param {AdtSpecificationActions} action
 * @returns {AdtSpecificationFormState}
 */
export function adtSpecificationFormReducer(
  state: AdtSpecificationFormState = initialState,
  action: AdtSpecificationActions,
): AdtSpecificationFormState {
  switch (action.type) {
    case ADT_SPECIFICATION_ACTION_TYPES.ADD_NEW_FORM:
      const counter = state.formsCounter + 1;
      return {
        ...state,
        forms: [
          ...state.forms,
          {
            id: counter,
            values: {},
            type: SpecificationFormEnum.PRODUCT_FORM,
          },
        ],
        formsCounter: counter,
      } as AdtSpecificationFormState;

    case ADT_SPECIFICATION_ACTION_TYPES.DELETE_FORM:
      return {
        ...state,
        forms: [...state.forms.filter((form) => form.id !== action.payload)],
      } as AdtSpecificationFormState;

    case ADT_SPECIFICATION_ACTION_TYPES.LOAD_CONFIG_COMPLETE:
      const canAddMultipleProducts = Boolean(action.payload['canAddMultipleProducts']);
      return {
        ...state,
        config: action.payload.fields,
        canAddMultipleProducts: canAddMultipleProducts,
      } as AdtSpecificationFormState;
    case ADT_SPECIFICATION_ACTION_TYPES.SET_CAN_ADD_MULTIPLE_PRODUCTS:
      return {
        ...state,
        canAddMultipleProducts: action.payload,
      } as AdtSpecificationFormState;

    case ADT_SPECIFICATION_ACTION_TYPES.SET_FORM_VALUES:
      return {
        ...state,
        forms: action.payload,
      } as AdtSpecificationFormState;

    case ADT_SPECIFICATION_ACTION_TYPES.RESET:
      return {
        ...initialState,
      } as AdtSpecificationFormState;
    case ADT_SPECIFICATION_ACTION_TYPES.RESET_FORM_VALUES:
      return {
        ...state,
        forms: initialState.forms,
        dateSelection: undefined,
      } as AdtSpecificationFormState;
    case ADT_SPECIFICATION_ACTION_TYPES.RESET_DATE_SELECTION:
      return {
        ...state,
        dateSelection: null,
      } as AdtSpecificationFormState;
    case ADT_SPECIFICATION_ACTION_TYPES.LOAD_MAIN_FORM_ID:
      return {
        ...state,
        mainFormId: action.payload,
      } as AdtSpecificationFormState;
    case ADT_SPECIFICATION_ACTION_TYPES.LOAD_DATE_SELECTION:
      return {
        ...state,
        dateSelection: action.payload,
      } as AdtSpecificationFormState;
    case ADT_SPECIFICATION_ACTION_TYPES.RESET_CONFIG:
      return {
        ...state,
        config: undefined,
      } as AdtSpecificationFormState;
    default:
      return state;
  }
}
